<template>
    <gz-auth-view-template :bc="false">
        <GZ-PageTitle title="Адреса" slot="title"/>        
        <!-- <GZ-StaticNotification slot="notification"/> -->
        
        <section slot="above-content" class="flex flex-ai-c flex-sb">
            <section>
                <button 
                    class="gz-icon_cercle gz-icon_cercle_default gz-icon_cercle_accent"
                    title="очистить фильтры"
                    style="margin-right: 20px"
                    @click="filters = filtersClear"
                >
                    <span class="icon-cleaning-1"></span>
                </button>
                <GZ-OptionSelect 
                    value="Сортировать список по дате проверки"
                    @update:select="sort($event)"
                />
            </section>

            <GZ-BaseButton 
                value="добавить адрес" 
                icon="icon-home-run" 
                class="gz-button_default gz-button_add-address" 
                slot="actions"
                @click="$router.push('add-address')"
            />
        </section>
              
        <section slot="content">
            <table class="gz-table">
                <thead class="gz-table__head">
                    <tr class="gz-table__filter-labels">
                        <td class="gz-table__filter-label"><span>Город</span></td>
                        <td class="gz-table__filter-label"><span>Улица</span></td>
                        <td class="gz-table__filter-label"><span>Дом</span></td>
                        <td class="gz-table__filter-label"><span>Тип дома</span></td>
                        <td class="gz-table__filter-label"><span>Этажность</span></td>
                        <td class="gz-table__filter-label"><span>Кол-во подъездов</span></td>
                        <td class="gz-table__filter-label"></td>
                    </tr>
                    <tr class="gz-table__filter">
                        <td>
                            <vue-autosuggest
                                class="gz-text-input gz-vue-autosuggest"
                                :suggestions="suggestionResult"
                                :input-props="{id: 'addresses-city-input', placeholder: filters.city ? filters.city : 'Введите название города'}"
                                @focus="suggestionResult = []"
                                @input="suggestions('city')"
                                @selected="filters.city = selectSuggestionOnSelect(filters, 'city').trim()"
                            ></vue-autosuggest>
                        </td>
                        <td>
                            <vue-autosuggest
                                class="gz-text-input gz-vue-autosuggest"
                                :suggestions="suggestionResult"
                                :input-props="{id: 'addresses-street-input', placeholder: filters.street ? filters.street : 'Введите название улицы'}"
                                @focus="suggestionResult = []"
                                @input="suggestions('street')"
                                @selected="filters.street = selectSuggestionOnSelect(filters, 'street').trim()"
                            ></vue-autosuggest>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.number = $event"
                                :imported-data="filters.number"
                                placeholder="Укажите номер дома"/>
                        </td>
                        <td>
                            <gz-select-container
                                type="filter"
                                class="gz-filter__item"
                                :dataList="filterBuildingType"
                                :imported-data="filters.type"
                                @selectedItem="filters.type = $event">
                                <GZ-TextInput
                                    :importedData="filters.type.name"
                                    :readonly="true"
                                    :selectType="true"
                                    placeholder="Выберите тип дома"/>
                            </gz-select-container>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.levelNum = $event"
                                :imported-data="filters.levelNum"
                                placeholder="Укажите этажность"/>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.porchNum = $event"
                                :imported-data="filters.porchNum"
                                placeholder="Укажите кол-во подъездов"/>
                        </td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        v-for="(item, $index) in responseData" 
                        :key="$index"
                        @click="$router.push('/admin/address/' + item.id + '/view-all')"
                        class="gz-table__row">
                        <td><span>{{ item.attributes.citytype }} {{ item.attributes.city }}</span></td>
                        <td><span>{{ item.attributes.street }}</span></td>
                        <td><span>{{ item.attributes.number }}</span></td>
                        <td><span>{{ mapType(item.attributes.type, filterBuildingType) }}</span></td>
                        <td><span>{{ item.attributes.levelNum }}</span></td>
                        <td><span>{{ item.attributes.porchNum }}</span></td>
                        <td>
                            <NextCheckupDate 
                                v-if="item.attributes.nextCheckupDate" 
                                :date="item.attributes.nextCheckupDate"
                                :isActive="false"
                            />
                        </td>
                    </tr>
                    <infinite-loading 
                        :identifier="infiniteId" 
                        @infinite="infiniteHandler"
                    ></infinite-loading>
                </tbody>
            </table>
        </section>        
    </gz-auth-view-template>
</template>

<script>
import NextCheckupDate from '@/components/custom/admin/views/addresses/BaseNextCheckupDate'
import mapType from '@/mixins/utils/types-mapper'

export default {
    name: 'AdminAddressesView',

    mixins: [mapType],
    components: {
        NextCheckupDate
    },
    data() {
        return {
            filters: {
                id: null,
                region: null,
                city: null,
                street: null,
                number: null,
                type: {
                    name: null,
                    value: null
                },
                construction: {
                    name: null,
                    value: null
                },
                levelNum: null,
                porchNum: null,
                sort: null,
                order: null
            },
            responseData: [],
            suggestionResult: [],

            //Pagination
            page: 0,
            infiniteId: +new Date(),

            filtersClear: {
                id: null,
                region: null,
                city: null,
                street: null,
                number: null,
                type: {
                    name: null,
                    value: null
                },
                construction: {
                    name: null,
                    value: null
                },
                levelNum: null,
                porchNum: null,
                sort: null,
                order: null
            }
        }
    },
    computed: {
        filterBuildingType() {
            return this.$store.getters['filterBuildingType']
        }
    },
    mounted() {
        if (localStorage.getItem('addressFilters')) {
            const ls = localStorage.getItem('addressFilters')
            this.filters = JSON.parse(ls)
            localStorage.removeItem('addressFilters')
        }
    },
    beforeDestroy() {
        const ls = JSON.stringify(this.filters)
        localStorage.setItem('addressFilters', ls)
    },
    methods: {        
        infiniteHandler($state) {
            const filters = this.filters
            
            this.$axios('building', {
                params: {
                    pg: this.page, 
                    batch: 10,
                    region: filters.region, 
                    city: filters.city, 
                    street: filters.street, 
                    number: filters.number, 
                    type: filters.type.value, 
                    construction: filters.construction.value, 
                    levelNum: filters.levelNum, 
                    porchNum: filters.porchNum, 
                    sort: filters.sort, 
                    order: filters.order
                }
            })
            .then(({data}) => {
                if (data.data.length) {
                    this.page += 1
                    this.responseData.push(...data.data)
                    $state.loaded()
                } else {
                    $state.complete()
                }
            })
            .catch(err => {
                console.error('Ошибка вывода списка объектов: ', err)
            })
        },        
        sort(state) {
            if (state) {
                this.filters.sort = 'nextCheckupDate'
                this.filters.order = 'ASC'
            } else {
                this.filters.sort = null
                this.filters.order = null
            }
        },
        suggestions(param) {
            let input = event.target.value
            
            if (input.length >= 2) {
                setTimeout(() => {
                    this.$axios({
                        method: 'GET',
                        url: 'building',
                        params: {
                            pg: 0,
                            batch: 10,
                            [param]: input
                        }
                    })
                    .then(response => {
                        this.suggestionResult = []
                        
                        let x = []
                        response.data.data.forEach(item => {
                            x.push(item.attributes[param])
                        })

                        //Уберем дубликаты
                        let y = x.filter((item, index) => {
                            return x.indexOf(item) == index
                        })

                        this.suggestionResult.push({data: y})
                    })
                }, 1000)
            }

            if (input.length < 2) {
                this.suggestionResult = []
            }
        },
        selectSuggestionOnSelect() {
            return  event.target.value || event.target.innerHTML
        }
    },
    watch: {
        filters: {
            handler() {
                this.page = 0
                this.responseData = []
                this.infiniteId += 1
            },
            deep: true
        } 
    }
}
</script>